import * as THREE from "../../../utils/basejs/three.min";

/*import {
    addSvg,
} from "../../../utils/basejs/addThreeThings";*/

/*import {
    addFont,
    addShape,
    addStableArrow,
    addConstShape,
    addConstFont
} from "../../../utils/basejs/addThreeThings";
import {LineGeometry} from "../../../utils/basejs/LineGeometry";
import {Line2} from "../../../utils/basejs/Line2";*/
// import {SVGLoader} from "../../../utils/basejs/SVGLoader";
import {LineGeometry} from "../../../utils/basejs/LineGeometry";
import {Line2} from "../../../utils/basejs/Line2";
import {addConstShape, addFont, clearScene} from "../../../utils/basejs/addThreeThings";

const saturationGroup = new THREE.Group();
function addLine ( lineGroup,mat, points, positions, name ) {
    const geometry = new LineGeometry();
    geometry.setPositions( points );
    const line = new Line2( geometry, mat );
    // line.scale.set( 1, 1, 1 );
    line.computeLineDistances();
    line.position.set( positions.x, positions.y, positions.z );
    if ( name ) {
        line.name = name;
    }
    lineGroup.add(line);
}
function clear(name){
    const object = saturationGroup.getObjectByName(name);
    if(object){
        saturationGroup.remove(object);
    }
}
function addGroup(group){
    saturationGroup.name = 'saturationGroup';
    group.add(saturationGroup);
}
function remove(name){
   const semp = saturationGroup.getObjectByName(name);
   if(semp){
       clearScene(semp);
   }
}
function addSempsData(semps,fontSize,width) {
    let semp = saturationGroup.getObjectByName('sempData');
    if (semp) {
        // saturationGroup.remove(semp);
        clearScene(semp);
    }else{
        semp  = new THREE.Group();
        semp.name = 'sempData';
        saturationGroup.add(semp);
    }
    const shapes = [];
    const textArray = [];
    if (semps) {
        const material = new THREE.MeshBasicMaterial({	color: 0x5072d9,side: THREE.DoubleSide});
        const position = {x: 0, y: 0, z: 0.2};
        for (let s of semps) {
            const sempShape = new THREE.Shape().moveTo(0, 0);
            const x = parseFloat(s.tbbtX);
            const minX = x - width;
            const maxX = x + width;
            const maxY = parseFloat(s.tbbtY);
            const minY = parseFloat(s.tbtpY);
            if(maxY > minY) {
                sempShape.lineTo(minX, minY).lineTo(minX, maxY).lineTo(maxX, maxY).lineTo(maxX, minY).lineTo(minX, minY);
                shapes.push({shape: sempShape, position: position, material: material, name: 'sempData'});
            }
            textArray.push({
                text: maxY + 'm',
                material: material,
                position: {x: x, y: maxY + 1, z: 0.4},
                size: fontSize
            });
        }
        addConstShape(shapes, semp);
        addFont(textArray,material,semp);
    }
}
function addThings(coreCoords,damCoords,semps,back,fontSize,damWidth){
    const core = saturationGroup.getObjectByName('core');
    const dam = saturationGroup.getObjectByName('dam');
    const backDam = saturationGroup.getObjectByName('back');
    let semp = saturationGroup.getObjectByName('semp');
    if(core){
        saturationGroup.remove(core);
    }
    if(dam){
        saturationGroup.remove(dam);
    }
    if(backDam){
        saturationGroup.remove(backDam);
    }
    if(semp){
        clearScene(semp);
    }else{
        semp  = new THREE.Group();
        semp.name = 'semp';
        saturationGroup.add(semp);
    }
    const shapes = [];
    if(coreCoords){
        // const material = new THREE.MeshBasicMaterial({	color: 0x808080,side: THREE.DoubleSide});
        const material = new THREE.MeshBasicMaterial({	color: 0xa9a9a9,side: THREE.DoubleSide});
        // #708090
        const coreShape = new THREE.Shape();
        let isFirst = true;
        let lastX = null;
        let lastY = null;

        for(let coords of coreCoords){
            if(isFirst){
                lastX = parseFloat(coords.x);
                lastY = parseFloat(coords.y);
                coreShape.moveTo(lastX,lastY)
                isFirst = false;
            }else{
                coreShape.lineTo(parseFloat(coords.x),parseFloat(coords.y));
            }

        }
        coreShape.lineTo(lastX,lastY);
        const position = {x:0,y:0,z:0.1};
        shapes.push({ shape: coreShape, position: position, material : material,name:'core'});//
    }
    if(damCoords){
        // const material = new THREE.MeshBasicMaterial({	color: 0x4EABFE,side: THREE.DoubleSide});
        const material = new THREE.MeshBasicMaterial({	color: 0x8b4513,side: THREE.DoubleSide});
        const damShape = new THREE.Shape();
        let isFirst = true;
        let lastX = null;
        let lastY = null;
        for(let coords of damCoords){
            if(isFirst){
                lastX = parseFloat(coords.x);
                lastY = parseFloat(coords.y);
                damShape.moveTo(lastX,lastY)
                isFirst = false;
            }else{
                damShape.lineTo(parseFloat(coords.x),parseFloat(coords.y));
            }

        }
        damShape.lineTo(lastX,lastY);
        const position = {x:0,y:0,z:0};
        shapes.push({ shape: damShape, position: position, material : material,name:'dam'});//
    }
    if(back){
        // const material = new THREE.MeshBasicMaterial({	color: 0x4EABFE,side: THREE.DoubleSide});
        const material = new THREE.MeshBasicMaterial({	color: 0xCD853F,side: THREE.DoubleSide});
        const backShape = new THREE.Shape();
        let isFirst = true;
        for(let coords of back){
            if(isFirst){
                backShape.moveTo(parseFloat(coords.x),parseFloat(coords.y))
                isFirst = false;
            }else{
                backShape.lineTo(parseFloat(coords.x),parseFloat(coords.y));
            }

        }
        const position = {x:0,y:0,z:0};
        shapes.push({ shape: backShape, position: position, material : material,name:'back'});//
    }
    addConstShape(shapes,saturationGroup);
    const sempsShape = [];
    const textArray = [];
    if(semps){
        // const material = new THREE.MeshBasicMaterial({	color: 0x4EABFE,side: THREE.DoubleSide});
        const material2 = new THREE.MeshBasicMaterial({	color: 0x6D6D6D});
        const material1 = new THREE.MeshBasicMaterial({	color: 0xEEE9E9,side: THREE.DoubleSide});
        const position = {x:0,y:0,z:0.2};
        for(let s of semps){
            const sempShape = new THREE.Shape().moveTo(0,0);
            const x = parseFloat(s.tbbtX);
            const minX = x - damWidth;
            const maxX = x + damWidth;
            const maxY = parseFloat(s.tbbtY);
            const minY = parseFloat(s.tbtpY);
            sempShape.lineTo(minX,minY).lineTo(minX,maxY).lineTo(maxX,maxY).lineTo(maxX,minY).lineTo(minX,minY);

            textArray.push({text:s.mpcd,material : material2,position:{x:x,y: maxY + 1,z:0.4},size:fontSize});
            sempsShape.push({ shape: sempShape, position: position, material : material1,name: s.mpcd});

        }
        addFont(textArray,material2,semp);
        addConstShape(sempsShape,semp);
    }


}
function addSaturationLine(mat,data,fontSize) {
    let line = saturationGroup.getObjectByName('saturationLine');
    if(line){
        clearScene(line);
    }else {
        line = new THREE.Group();
        line.name = 'saturationLine';
        saturationGroup.add(line);
    }
    const points = [];
    const textArray = [];
    const material = new THREE.MeshBasicMaterial({	color: 0x5072d9,side: THREE.DoubleSide});
    for(let d of data){
        points.push(parseFloat(d.x),parseFloat(d.y),0);
        if(d.name){
            textArray.push({text: '▼库水位('+d.y + 'm)',material : material,position:{x:parseFloat(d.x),y: parseFloat(d.y) + 1,z:0.4},size:fontSize});
        }
    }
    const position = {x:0,y:0,z:0.3};
    addLine(line,mat,points,position,undefined);
    addFont(textArray,material,line);
}
// export {timeConstShapeGroup,timeShapeGroup,timeLineGroup,timeFontGroup,timeStableArrowGroup,timeDataShowGroup,timeDyShow,timeDyTextShow,addThings,addSystemLine,addDyysGroup};
export {addGroup,addThings,addSaturationLine,clear,addSempsData,remove};
